<svelte:options accessors/>
<script lang="ts">
    import MainOverlay from "./MainOverlay.svelte";
    import Title from "../atoms/Title.svelte";
    import SlideOver from "./SlideOver.svelte";
    import Whatsapp from "./Whatsapp.svelte";

    export let data = [];
    export let open = false;
    export let sign = false;
    export let title: string = 'Todo para tu Nissan'

    let active = null;
    let subactive = null;

    function reset() {
        active = null;
        subactive = null;
    }

    function resetsub() {
        subactive = null;
    }


</script>

<SlideOver bind:open={open} left="{true}" maxWidth="340px">
    <div class="box-b">
        <h2 class="mb-15">{title}</h2>
        <div on:click={()=> open = false} class="pointer"
             style="font-family:sans-serif; font-weight:300; font-size:24px;">&times;
        </div>
    </div>

    {#if !active}
        {#each data as section (section.slug)}
            <div class="box-b py-1 relative pointer menu-option">
                <div style="font-size:15px">{section.label}</div>
                <div>
                    <img height="17" src="/static/storefront/pix/icons/chevron-gray.svg" alt="Chevron">
                </div>
                {#if section.submenu}
                    <div class="absolute edges-0" on:click={()=>active = section.slug}></div>
                {:else}
                    <a href="{section.route}" class="absolute edges-0 block"></a>
                {/if}
            </div>
        {/each}
    {:else}
        {#each data as section (section.slug)}
            {#if section.slug === active && subactive == null }
                <div class="my-1">
                    <Title title="{section.label}" on:click={reset}/>
                </div>

                {#each section.sub as sub (sub.slug)}
                    <div class="box-b py-1 relative pointer menu-option">
                        <div style="font-size:15px">{sub.label}</div>
                        <div>
                            <img height="17" src="/static/storefront/pix/icons/chevron-gray.svg" alt="Chevron">
                        </div>
                        {#if sub.submenu}
                            <div class="absolute edges-0" on:click={()=>subactive = sub.slug}></div>
                        {:else}
                            <a href="{sub.route}" class="absolute edges-0 block"></a>
                        {/if}
                    </div>
                {/each}

            {:else if section.slug === active && subactive !== null}
                {#each section.sub as sub (sub.slug)}
                    {#if sub.slug === subactive}
                        <div class="my-1">
                            <Title title="{sub.label}" on:click={resetsub}/>
                        </div>
                        {#each sub.sub as subsub (subsub.slug)}
                            <div class="box-b py-1 relative pointer menu-option">
                                {#if subsub.route}
                                    <a class="next" href={subsub.route} style="font-size:15px">{subsub.label}</a>
                                {:else}
                                    <div style="font-size:15px">{subsub.label}</div>
                                {/if}
                                <div>
                                    {#if subsub.route}
                                        <a href={subsub.route}>
                                            <img height="17" src="/static/storefront/pix/icons/chevron-gray.svg"
                                                 alt="Chevron">
                                        </a>
                                    {:else}
                                        <img height="17" src="/static/storefront/pix/icons/chevron-gray.svg"
                                             alt="Chevron">
                                    {/if}
                                </div>
                            </div>
                        {/each}
                    {/if}
                {/each}
            {/if}
        {/each}
    {/if}

    <div slot="actions">
        <Whatsapp/>
    </div>

</SlideOver>
<style>
    .menu-option:active {
        background: #f3f4f5;
    }
    .next {
        color: inherit !important;
        text-decoration: none !important;
    }
</style>